export var DebriefFactSource;
(function (DebriefFactSource) {
    DebriefFactSource["Jira"] = "jira";
    DebriefFactSource["Sharepoint"] = "share_point";
    DebriefFactSource["Confluence"] = "confluence";
    DebriefFactSource["Manual"] = "manual";
})(DebriefFactSource || (DebriefFactSource = {}));
export var DebriefStage;
(function (DebriefStage) {
    DebriefStage["GoalAndLeadDefinition"] = "goal-and-lead-definition";
    DebriefStage["TeamAssembly"] = "team-assembly";
    DebriefStage["Planning"] = "planning";
    DebriefStage["Execution"] = "execution";
    DebriefStage["MonitoringAndControl"] = "monitoring-and-control";
    DebriefStage["CompletionAndApproval"] = "completion-and-approval";
})(DebriefStage || (DebriefStage = {}));
export var DebriefV2OutcomeResult;
(function (DebriefV2OutcomeResult) {
    DebriefV2OutcomeResult["Achieved"] = "achieved";
    DebriefV2OutcomeResult["NotAchieved"] = "not_achieved";
})(DebriefV2OutcomeResult || (DebriefV2OutcomeResult = {}));
